"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.upgrade.subject': 'Account aggiornato con successo',
    'email.upgrade.title': 'Il tuo account è stato aggiornato!',
    'email.upgrade.text': 'Ottime notizie! Il tuo account è stato aggiornato con successo e ora hai accesso a funzionalità avanzate.',
    'email.upgrade.new_plan': 'Nuovo Piano',
    'email.upgrade.benefits': 'Ora puoi godere di tutti i vantaggi del tuo nuovo piano di abbonamento.',
    'email.upgrade.dashboard_button': 'Vai alla Dashboard',
    'email.upgrade.footer': 'Grazie per aver scelto IntHub!',
};
